<template>
    <div class="container mt-4">
        <div class="row" v-if="!mainScreen">
            <div class="h3 mt-4">You entered age {{ userAgeValue}}</div>
            <div class="col-12 h-100">
                <form @submit.prevent="calculate_sdc_risk">
                    <div class="form-group row mt-3">
                        <div class="col-4 col-form-label">
                            {{ sexLabel }}
                        </div>
                        <div class="col-8 pr-2 mt-2">
                            <div>
                                <label for="male">
                                    <input type="radio" name="sex" id="male" autocomplete="off" v-model="sex_range"
                                        value="0" aria-describedby="male" aria-label="Sex male" checked/>
                                    Male
                                </label>
                                <label for="female" class="ml-4">
                                    <input type="radio" name="sex" id="female" autocomplete="off" v-model="sex_range"
                                        value="1" aria-describedby="female" aria-label="Sex female"/>
                                    Female
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="Height" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol">{{heightLabel}}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="Height" placeholder="25 to 190"
                                    @input="handleUpperInput('height')" v-model="hgt_cm" @blur="validationFiled('Height')" aria-describedby="Height" />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="cm" title="cm">cm</div>
                                        </p>
                                    </div>
                                    <!-- <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('height')"
                                            key="lasize-input">i</a>
                                    </div> -->
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ heightValidationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="heightRangeIcon">Height must be between 25 and 190 cm.</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="Weight" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol">{{weightLabel}}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="Weight" placeholder="1 to 150"
                                    @input="handleUpperInput('weight')"  v-model="wgt_kg" @blur="validationFiled('weight')" aria-describedby="Weight" />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="kg" title="kg">kg</div>
                                        </p>
                                    </div>
                                    <!-- <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('weight')"
                                            key="lasize-input">i</a>
                                    </div> -->
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ weightValidationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="weightRangeIcon">Weight must be between 1 and 150 kg</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="la_systole_mm" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol"> {{laSizeLabel}}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="la_systole_mm" placeholder="3 to 80"
                                        v-model="la_systole_mm" @blur="validationFiled('la_systole_mm')"
                                        @input="handleUpperInput('la_systole_mm')" aria-describedby="Left atrial diameter at end-systole must be between 5 and 55 mm." />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="mm" title="mm">mm</div>
                                        </p>
                                    </div>
                                    <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('la_systole_mm')"
                                            key="lasize-input">i</a>
                                    </div>
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ la_systole_mm_validationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="la_systole_mmRangeIcon">{{laSizeHelpText}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="peak_grad_mmhg" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol"> {{maxLvotGradientLabel}}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="peak_grad_mmhg"
                                        placeholder="0 to 210" v-model="peak_grad_mmhg"
                                        @blur="validationFiled('peak_grad_mmhg')"
                                        @input="handleUpperInput('peak_grad_mmhg')" aria-describedby="PeakLVoutflowtractgradient" />
                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="mmHg" title="mmHg">mmHg</div>
                                        </p>
                                    </div>
                                    <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('peak_grad_mmhg')"
                                            key="lasize-input">i</a>
                                    </div>
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ peak_grad_mmhg_validationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="peak_grad_mmhgRangeIcon">{{maxLvotGradientHelpText}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="lvpwd_mm" class="col-form-label">
                                    <span class="abbr">
                                        <div title="mlvwtLabel"> {{mlvwtLabel}}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="lvpwd_mm" placeholder="4 to 70"
                                        v-model="lvpwd_mm" @blur="validationFiled('lvpwd_mm')"
                                        @input="handleUpperInput('lvpwd_mm')" aria-describedby=" Maximum left ventricular posterior wall diameter (mm):" />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="mm" title="mm">mm</div>
                                        </p>
                                    </div>
                                    <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('lvpwd_mm')"
                                            key="lasize-input">i</a>
                                    </div>
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ lvpwd_mm_validationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="lvpwd_mmRangeIcon">{{mlvwtHelpText}}</p>
                            </div>
                        </div>
                    </div>
                   
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="ivsd_mm" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol">{{ isdLabel }}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="ivsd_mm" placeholder="0.5 to 43"
                                    @input="handleUpperInput('ivsd_mm')" v-model="ivsd_mm" @blur="validationFiled('ivsd_mm')"
                                        aria-describedby="ivsd_mm" />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="mm" title="mm">mm</div>
                                        </p>
                                    </div>
                                    <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('ivsd_mm')"
                                            key="lasize-input">i</a>
                                    </div>
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ ivsd_mm_validationError }}</p>
                                <p class="toolTip mt-3" role="alert" v-if="ivsd_mmRangeIcon">{{ isdHelpText }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-row mb-4 align-items-center">
                        <div class="col-12">
                            <div class="col-8 pl-0 float-left">
                                <label for="posterLVWall" class="col-form-label">
                                    <span class="abbr">
                                        <div title="Total Cholesterol">{{ posteriorLvLabel }}
                                        </div>
                                    </span>
                                </label>
                                <div class="d-flex justify-content-center">
                                    <input type="text" class="form-control" id="posterLVWall" placeholder="0.5 to 60"
                                    @input="handleUpperInput('posterLVWall')" v-model="posterLVWall" @blur="validationFiled('posterLVWall')"
                                        aria-describedby="posterLVWall" />

                                    <div class="float-left clearfix lower ml-4 mt-2">
                                        <p class="float-left">
                                        <div id="mm" title="mm">mm</div>
                                        </p>
                                    </div>
                                    <!-- <div class=" float-left clearfix lower mt-1">
                                        <a class="ml-4 icon" @click="handleIconValidatoin('ivsd_mm')"
                                            key="lasize-input">i</a>
                                    </div> -->
                                </div>
                                <p class="text-danger errorMessage" role="alert">
                                    {{ posterLVWall_validationError }}</p>
                                <!-- <p class="toolTip mt-3" role="alert" v-if="ivsd_mmRangeIcon">{{ isdHelpText }}</p> -->
                            </div>
                        </div>
                    </div>
                  
                    <!-- <div class="form-group row mt-3">
                        <div class="col-8">
                            <div class="d-flex justify-align-center">
                                <label>
                                    History of nonsustained ventricular
                                    tachycardia in prior 6 months:
                                </label>
                                <div class=" float-left clearfix lower mt-0">
                                    <a class="ml-4 icon" @click="handleIconValidatoin('HistoryVentricular')"
                                        key="lasize-input">i</a>
                                </div>
                            </div>
                            <div class="col-4 pr-2 mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="History of nonsustained ventricular
                                    tachycardia in prior 6 months_no">
                                        <input type="radio" name="History of nonsustained ventricular
                                    tachycardia in prior 6 months"
                                            id="Historyofnonsustainedventriculartachycardiaprior6months_No"
                                            autocomplete="off" aria-label="History of nonsustained ventricular
                                    tachycardia in prior 6 months" value="0" v-model="hx_nsvt" checked />
                                        No
                                    </label>
                                    <label for="History of nonsustained ventricular
                                    tachycardia in prior 6 months_yes" class="ml-4">
                                        <input type="radio" name="History of nonsustained ventricular
                                    tachycardia in prior 6 months"
                                            id="Historyofnonsustainedventriculartachycardiainprior6months_Yes"
                                            aria-label="History of nonsustained ventricular
                                    tachycardia in prior 6 months yes" autocomplete="off" value="1"
                                            v-model="hx_nsvt" />
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <p class="toolTip mt-3" role="alert" v-if="HistoryVentricularRangeIcon"> History of nonsustained ventricular
                                tachycardia in prior 6 months.</p>
                        </div>
                    </div> -->
                    <!-- <div class="form-group row mt-3">
                        <div class="col-6">
                            <div class="d-flex justify-align-center">
                                <label>
                                    History of unexplained syncope in prior 6
                                    months:</label>
                                <div class=" float-left clearfix lower mt-0">
                                    <a class="ml-4 icon" @click="handleIconValidatoin('HistoryUnexplained')"
                                        key="lasize-input">i</a>
                                </div>
                            </div>
                            <div class="col-8 pr-2 mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="History of unexplained syncope in prior months No">
                                        <input type="radio" name="History of unexplained syncope in prior 6
                                    months" id="Historyofunexplainedsyncopeinpriormonths" autocomplete="off"
                                            aria-label="History of unexplained syncope in prior 6 months" value="0"
                                            checked v-model="hx_syncope" />
                                        No
                                    </label>
                                    <label for="History of unexplained syncope in prior months yes" class="ml-4">
                                        <input type="radio" name="History of unexplained syncope in prior months"
                                            id="Historyofunexplainedsyncopeinpriormonths"
                                            aria-label="History of unexplained syncope in prior months Yes"
                                            autocomplete="off" v-model="hx_syncope" value="1" />
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <p class="toolTip mt-3" role="alert" v-if="HistoryUnexplainedRangeIcon">History of unexplained syncope in prior 6
                                months.</p>
                        </div>
                    </div> -->
                    <div class="form-group row mt-3">
                        <div class="col-4">
                            <div class="d-flex justify-align-center">
                                <label> {{ gsLabel }}</label>
                               
                            </div>
                        </div>
                        <div class="col-8 pr-2 mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="Genotype status Not Tested">
                                        <input type="radio" name="Genotype status Not Tested" id="NotTested"
                                            autocomplete="off" aria-label="Genotype status_Not Tested" value="0" checked
                                            v-model="genotype_mutation" @change="handleChange('notTested')" />
                                        Not Tested
                                    </label>
                                    <label for="Genotype status_Tested" class="ml-4">
                                        <input type="radio" name="Genotype status_Tested" id="Genotystatus_Tested"
                                            aria-label="Genotype status Tested" autocomplete="off"
                                            v-model="genotype_mutation" value="1" @change="handleChange" />
                                        Tested
                                    </label>
                                </div>
                            </div>
                            <p class="toolTip mt-3" role="alert" v-if="GenotypestatusRangeIcon">{{gsHelpText}}</p>
                    </div>
                    <div class="form-group row mt-3" v-if="genoTypePossitive">
                        <div class="col-md-4 col-4">
                            <div class="d-flex justify-align-center">
                                <label>{{gpLabel}}</label>
                                
                            </div>
                           
                        </div>
                        <div class="col-md-3 col-5  pr-2 mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="Genotype possitive_no">
                                        <input type="radio" name="Genotype possitive_no" id="NotTested"
                                            autocomplete="off" aria-label="Genotype possitive_no" value="0" checked
                                            v-model="genotype_mutation_yes" />
                                        No
                                    </label>
                                    <label for="Genotype possitive_yes" class="ml-4">
                                        <input type="radio" name="Genotype possitive_yes" id="Genotype _possitive_yes"
                                            aria-label="Genotype possitive_yes" autocomplete="off"
                                            v-model="genotype_mutation_yes" value="1" @change="handleChange" />
                                        Yes
                                    </label>
                                </div>
                               
                            </div>
                            <div class="col-md-2 col-2">
                                <a class="ml-4 icon" @click="handleIconValidatoin('Genotypepositive')"
                                        key="lasize-input">i</a>
                            </div>
                            <div class="col-12 col-md-8">
                                <p class="toolTip mt-3" role="alert" v-if="GenotypepositiveRangeIcon">{{gpHelpText}}</p>
                           </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-md-4 col-4">
                            <div class="d-flex justify-align-center">
                                <label>{{nsvtLabel}}</label>
                            </div>
                        </div>
                        <div class="col-md-3 col-5  mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="Non-sustained ventricular tachycardia_no">
                                        <input type="radio" name="Non-sustained ventricular tachycardia_no"
                                            id="NotTested" autocomplete="off"
                                            aria-label="Non-sustained ventricular tachycardia_no" value="0" checked
                                            v-model="non_vt" />
                                        No
                                    </label>
                                    <label for="Non-sustained ventricular tachycardia_yes" class="ml-4">
                                        <input type="radio" name="Non-sustained ventricular tachycardia_yes"
                                            id="Non-sustained ventricular tachycardia_yes"
                                            aria-label="Non-sustained ventricular tachycardia_yes" autocomplete="off"
                                            v-model="non_vt" value="1" />
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 col-2 ">
                                <a class="ml-4 icon" @click="handleIconValidatoin('nonVt')" key="lasize-input">i</a>
                            </div>
                           <div class="col-12 col-md-8">
                            <p class="toolTip mt-3" role="alert" v-if="nonVtRangeIcon">{{nsvtHelpText}}</p>
                           </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-md-4 col-4">
                            <div class="d-flex justify-align-center">
                                <label>{{usLabel}}:</label>
                        </div>
                       
                    </div>
                            <div class="col-md-3 col-5 mt-2">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label for="Unexplained syncope_no">
                                        <input type="radio" name="Unexplained syncope_no" id="UnexplainedSyncope_no"
                                            autocomplete="off" aria-label="Unexplained syncope_no" value="0" checked
                                            v-model="un_sy" />
                                        No
                                    </label>
                                    <label for="Unexplained syncope_yes" class="ml-4">
                                        <input type="radio" name="Unexplained syncope_yes" id="Unexplained syncope_yes"
                                            aria-label="Unexplained synco_yes" autocomplete="off" v-model="un_sy"
                                            value="1" />
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 col-2 mt-0">
                                <a class="ml-4 icon" @click="handleIconValidatoin('UnexplainedSyncope')"
                                key="lasize-input">i</a>
                            </div>
                             <div class="col-12 col-md-8">
                                <p class="toolTip mt-3" role="alert" v-if="UnexplainedSyncopeIcon">{{ usHelpText }}</p>
                           </div>
                    </div>
                    <div class="form-group row">
                        <div v-if="isLoading" class="col col-md-12 text-center text-lg-left">
                            <button class="btn btn-primary" type="button" value="loadong" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                            <input class="btn btn-outline ml-3" @click="resetForm" type="reset" key="reset"
                                value="Reset" />
                        </div>
                        <div v-else class="col col-md-12 text-center text-lg-left">
                            
                            <input class="btn btn-primary"  @click = "handleBackScreen" type = "button" value="Back"  key="back"  />
                            <a href="#" v-b-modal="'validationModal'" class="btn btn-primary" type="submit"  @click="formValidate" value="Calculate" key="submit" >Submit</a>
                            <input class="btn btn-outline ml-3" type="reset" key="reset" @click="resetForm" value="Reset" />
                        </div>
                        <div class="d-flex justify-content-between w-100 align-center ">
                            <p class="col-sm-12 col-md-6 c-daily-journey__slide-number mt-3">2 of 3</p>
                            <p class="p col-sm-12 col-md-6 mt-3" v-html = "calculatorVersionText"></p>
                         
                    </div>
                        </div>
                         
                </form>
            </div>
        </div>
        <div  class="c-hero-card__container col-6" v-if="validationModal">
                <aha-modal :interval="0" id="validationModal" ref="validationModal" class="c-modal--generic"
            title="Modal Header" hide-footer centered scrollable>
            <div class = "h3 text-left validation-modal-header" v-html="errorModalHeaderText"></div>
            <div class = "h4 text-left mt-4 ">HCM Risk Kids Score</div> 
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="wgt_kg === ''"> - Weight field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if="wgt_kg > 150 || wgt_kg < 2"> - Weight must be between 2 and 150 kg.</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="la_systole_mm === '' "> - LA size field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if="la_systole_mm > 80 || la_systole_mm < 3"> - LA Size must be between 3 and 80 mm.</div>
            </div>
            
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="lvpwd_mm === '' "> - MLVWT field is missing</div>
                <!-- <div class="ml-3 text-left validation-modal-style" v-else-if="lvpwd_mm > 70 || lvpwd_mm < 4 ">- MLVWT must be between 4 and 70 mm</div> -->
                <div class="ml-3 text-left validation-modal-style" v-else-if="lvpwd_mm > 70 || lvpwd_mm < 4 ">- MLVWT must be between 4 and 70 mm</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="peak_grad_mmhg === '' "> - Max LVOT Gradient field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" peak_grad_mmhg > 200 || peak_grad_mmhg < 0"> - Max LVOT Gradient must be between 0 and 200 mmHg.</div>
            </div>
            
            <div class = "h4 text-left mt-4 ">PRIMaCY Risk Kids Score</div>
            <div>
                  <div class="ml-3 text-left validation-modal-style" v-if="wgt_kg === ''"> - Weight field is missing</div>
                  <div class="ml-3 text-left validation-modal-style" v-else-if="wgt_kg > 150 || wgt_kg < 1"> - Weight must be between 1 and 150 kg</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="hgt_cm === ''"> - Height field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" hgt_cm > 190 || hgt_cm < 25"> - Height must be between 25 and 190 cm.</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="la_systole_mm === '' "> - LA size field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" la_systole_mm > 55 || la_systole_mm < 5"> -  LA Size must be between 5 and 55 mm.</div>
            </div>
           
            <!-- <div>
                <div class="ml-3 text-left validation-modal-style" v-if="lvpwd_mm === '' "> -  MLVWT field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" lvpwd_mm > 60 || lvpwd_mm < 0.5"> - MLVWT must be between 0.5 and 60 mm.</div>
            </div> -->
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="ivsd_mm === '' "> - Interventricular Septal Diameter field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" ivsd_mm > 43|| ivsd_mm < 0.5"> - Interventricular Septal Diameter must be between 0.5 and 43 mm</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="peak_grad_mmhg === '' "> - Max LVOT Gradient field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if=" peak_grad_mmhg > 210 || peak_grad_mmhg < 0"> - Max LVOT Gradient must be between 0 and 210 mmHg.</div>
            </div>
            <div>
                <div class="ml-3 text-left validation-modal-style" v-if="posterLVWall === '' "> - Posterior LV Wall Diameter field is missing</div>
                <div class="ml-3 text-left validation-modal-style" v-else-if="posterLVWall > 60 || posterLVWall < 0.5"> - Posterior LV Wall Diameter must be between 0.5 and 60 mm.</div>
            </div>

            <p class="mt-3 h6 text-left" v-html="errorModalFooterText"></p>
            <div class="d-flex justify-content-between mt-4">
                <div class="btn btn-outline-danger" @click = "validationBack" >Back</div>
                <div class="btn btn-primary" @click = "calculate_sdc_risk">See Results</div>
            </div>
        </aha-modal>
            </div>
        <div v-if="isShowModal">
            <div class="h4">Estimated risk of SCD at 5 years (%) for age {{ userAgeValue}}</div>
            <div class="p" v-html="riskHeaderText"></div>
            <div class="row justify-content-md-center  justify-content-sm-center mt-4 " >
            
           <div class="col-md-6 col-sm-12  mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4" v-if="riskKidsCalculatorResultValidation && userAgeValue > 0">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading h4 d-flex justify-content-center text-center">HCM Risk Kids Score</p>
                    <P class="c-hero-card__subheading h1 d-flex justify-content-center font-weight">{{  RiskKidsTotalResult }}</P>
                    
                        <a href="#" v-b-modal="'HCMRisk'" class="c-cta c-cta--arrow h-theme--red custom-cal-link">{{ hcmRiskKidsScoreLabel }}</a>
                </div>
                <aha-modal :interval="0" id="HCMRisk" ref="HCMRisk" class="c-modal--generic"
            title="Modal Header" hide-footer centered scrollable>            <div class="c-hero-card-snackable-full-quiz align-self-start">
                            <div class="" aria-live="polite">
                               
                                    <div  class ="text-left" v-html="hcmRiskKidsScoreDescription"></div>                                
                                
                            </div>
                        </div>             
        </aha-modal>
            </div>
          
            <div class="col-md-6 col-sm-12  mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4" v-if="primacyCalculatorResulatValidation">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading d-flex h4 justify-content-center text-center">PRIMaCY Risk Score</p>
                    <P class="c-hero-card__subheading h1 d-flex justify-content-center font-weight">{{ primacyTotalResult }}</P>
                   
                    <a href="#" v-b-modal="'primacyCal'" class="c-cta c-cta--arrow h-theme--red custom-cal-link">{{primacyRiskScoreLabel}}</a>
                   
                </div>
                <aha-modal :interval="0" id="primacyCal" ref="primacyCal" class="c-modal--generic"
            title="Modal Header" hide-footer centered scrollable>
                        <div class="c-hero-card-snackable-full-quiz align-self-start">
                            <div class="" aria-live="polite">
                                
                                   <div  class ="text-left" v-html="primacyRiskScoreDescription"> </div>                              
                            </div>
                        </div>                      
        </aha-modal>
            </div>

            <div class="p mt-4 mb-4 ml-3 " v-html = "resultGuidelineText"> </div>
               
           
            <!-- Popup modal text message only -->
            <!-- <div class="col-md-6 col-sm-12  mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4" v-if="riskKidsCalculatorResultValidation && userAgeValue > 0">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading h4 d-flex justify-content-center text-center">HCM Risk Kids Recommendation</p>
                    <p class="c-hero-card__subheading h5 d-flex justify-content-center font-weight text-center custom-recommedation-text">No formal recommendation for Risk Kids</p>
                </div>
               
            </div>
          
            <div class="col-md-6 col-sm-12  mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4" v-if="primacyCalculatorResulatValidation">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading d-flex h4 justify-content-center text-center">PRIMaCY Risk Recommendation</p>
                    <p class="c-hero-card__subheading h5 d-flex justify-content-center font-weight text-center custom-recommedation-text">No formal recommendation for PRIMaCY</p>
                </div>
                
            </div> -->
           
        </div>
        <div class="d-flex justify-content-left align-center mt-4 h4">
            {{patientSelectionLabel}}
        </div>
        <div class="d-flex justify-content-center align-center mt-4">
          <div v-html="hcmRecommendationDescription"></div>
          
        </div>
        <p class="c-daily-journey__slide-number d-flex justify-content-center mt-4">3 of 3</p>
        <div class = "d-flex justify-content-center mt-3">
        <button type="button" step-index="1" class="p-0 my-4 bg-white border-0 custom-start-over" @click = "handleReload">
            <img src="/assets/glyphs/retake-quiz-Icon.svg" /> <span class="text-primary" >Start Over</span>
        </button>
    </div>
    </div>
    </div>
</template>
<script>
// import Vue from 'vue';
/* eslint-disable */
import HcmScdCalculator from './hcm-scd-calculator.vue';
import RiskKidsPrimacy from './risk-kids-primacy.vue';

const {
    age_oth_spline,
    age_scd_spline,
    grad_scd_spline,
    la_scd_spline,
    lvpwd_scd_spline,
    ivsd_scd_spline,
} = require("./primacy-cal-js/spline_functions");
const { cif_scd } = require("./primacy-cal-js/baseline_hazard");
const z_functions_1 = require("./primacy-cal-js/z_functions");
const genotype_spline_functions_1 = require("./primacy-cal-js/genotype_spline_functions");
const no_genotype_spline_functions_1 = require("./primacy-cal-js/no_genotype_spline_functions");
const genotype_baseline_hazard_1 = require("./primacy-cal-js/genotype_baseline_hazard");
const no_genotype_baseline_hazard_1 = require("./primacy-cal-js/no_genotype_baseline_hazard");

export default {
    components: {
        HcmScdCalculator,
        RiskKidsPrimacy
    },
    props: {
        hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
        posteriorLvLabel:{
            type: String,
            required: true
        },
        posteriorLvErrorMessage:{
            type: String,
            required: true
        },
        riskHeaderText:{
            type: String,
            required: true
        },
        resultGuidelineText: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },
    userAgeValue: {
      type: String,
      required: true
    },
    handleFirstScreen: Function,
    heightErrorMessage:{
            type: String,
            required: true
        },
        weightErrorMessage:{
            type: String,
            required: true
        },
        laSizeErrorMessage:{
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage:{
            type: String,
            required: true
        },
        mlvwtErrorMessage:{
            type: String,
            required: true
        },
        isdErrorMessage:{
            type: String,
            required: true
        },
        sexLabel:{
            type: String,
            required: true
        },
        heightLabel:{
            type: String,
            required: true
        },
        weightLabel:{
            type: String,
            required: true
        },
        laSizeLabel:{
            type: String,
            required: true
        },
        maxLvotGradientLabel:{
            type: String,
            required: true
        },
        mlvwtLabel:{
            type: String,
            required: true
        },
        isdLabel:{
            type: String,
            required: true
        },
        gpLabel:{
            type: String,
            required: true
        },
        usLabel:{
            type: String,
            required: true
        },
        nsvtLabel:{
            type: String,
            required: true
        },
        gsLabel:{
            type: String,
            required: true
        },
        efLabel:{
            type: String,
            required: true
        },
        fhscdLabel:{
            type: String,
            required: true
        },
        aaLabel:{
            type: String,
            required: true
        },
        lgeLabel:{
            type: String,
            required: true
        },
        laSizeHelpText:{
            type: String,
            required: true
        },
        maxLvotGradientHelpText:{
            type: String,
            required: true
        },
        mlvwtHelpText:{
            type: String,
            required: true
        },
        isdHelpText:{
            type: String,
            required: true
        },
        gpHelpText:{
            type: String,
            required: true
        },
        usHelpText:{
            type: String,
            required: true
        },
        nsvtHelpText:{
            type: String,
            required: true
        },
        gsHelpText:{
            type: String,
            required: true
        },
        efHelpText:{
            type: String,
            required: true
        },
        fhscdHelpText:{
            type: String,
            required: true
        },
        aaHelpText:{
            type: String,
            required: true
        },
        lgeHelpText:{
            type: String,
            required: true
        },
        hcmRiskKidsScoreLabel:{
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription:{
            type: String,
            required: true
        },
        primacyRiskScoreLabel:{
            type: String,
            required: true
        },

        primacyRiskScoreDescription:{
            type: String,
            required: true
        },
        lvmwtZScoreLabel:{
            type: String,
            required: true
        },

        lvmwtZScoreDescription:{
            type: String,
            required: true
        },
        laDiameterZScoreLabel:{
            type: String,
            required: true
        },

        laDiameterZScoreDescription:{
            type: String,
            required: true
        },
        hcmScdScoreLabel:{
            type: String,
            required: true
        },

        hcmScdScoreDescription:{
            type: String,
            required: true
        },
        prognosticIndexLabel:{
            type: String,
            required: true
        },

        prognosticIndexDescription:{
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        },

  },

    data() {
        return {
            sex_range: 0,
            isShowModal: false,
            hgt_cm: "",
            wgt_kg: "",
            ivsd_mm: "",
            lvpwd_mm: "",
            la_systole_mm: "",
            peak_grad_mmhg: "",
            hx_nsvt: 0,
            hx_syncope: 0,
            testedStatus: "",
            primacyTotalResult: "",
            RiskKidsTotalResult: "",
            ageValidationError: "",
            heightValidationError: "",
            weightValidationError: "",
            ivsd_mm_validationError: "",
            lvpwd_mm_validationError: "",
            la_systole_mm_validationError: "",
            peak_grad_mmhg_validationError: "",
            isLoading: "",
            ageValidation: false,
            heightValidation: false,
            weightValidation: false,
            ivsd_mm_Validation: false,
            lvpwd_mm_validation: false,
            la_systole_mm_validation: false,
            peak_grad_mmhg_validation: false,
            genoTypePossitive: false,
            genotype_mutation: 0,
            genotype_mutation_yes: 0,
            non_vt: 0,
            un_sy: 0,
            lv_Zz_score: "",
            heightRangeIcon: false,
            weightRangeIcon: false,
            ivsd_mmRangeIcon: false,
            lvpwd_mmRangeIcon: false,
            la_systole_mmRangeIcon: false,
            peak_grad_mmhgRangeIcon: false,
            lv_Zz_scoregRangeIcon: false,
            ladiascoreRangeIcon: false,
            HistoryVentricularRangeIcon: false,
            HistoryUnexplainedRangeIcon: false,
            GenotypestatusRangeIcon: false,
            GenotypepositiveRangeIcon: false,
            nonVtRangeIcon: false,
            UnexplainedSyncopeIcon: false,
            PrognosticTotal: "",
            riskKidsCalculatorResultValidation: false,
            primacyCalculatorResulatValidation: false,
            validationModal: false,
            mainScreen : false,
            posterLVWall: "",
            posterLVWall_validationError: ""
        };
    },
    computed: {
        canShowTotalResult() {
            return (
                this.ageValidation === false &&
                this.heightValidation === false &&
                this.weightValidation === false &&
                this.ivsd_mm_Validation === false &&
                this.lvpwd_mm_validation === false &&
                this.la_systole_mm_validation === false &&
                this.peak_grad_mmhg_validation === false &&
                this.hgt_cm !== "" &&
                this.wgt_kg !== "" &&
                this.ivsd_mm !== "" &&
                this.lvpwd_mm !== "" &&
                this.la_systole_mm !== "" &&
                this.peak_grad_mmhg !== ""
            );
        },
    },
    methods: {
        handleUpperInput(inputKey) {
            if(inputKey === 'height'){
                this.hgt_cm = this.hgt_cm.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'weight'){
                this.wgt_kg = this.wgt_kg.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'ivsd_mm'){
                this.ivsd_mm = this.ivsd_mm.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'lvpwd_mm'){
                this.lvpwd_mm = this.lvpwd_mm.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'la_systole_mm'){
                this.la_systole_mm = this.la_systole_mm.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'peak_grad_mmhg'){
                this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
            }
        },

        handleBackScreen() {
            this.handleFirstScreen();
        },

        handleReload() {
            window.location.reload();
        },
        handleChange(notTested) {
            if (notTested === "notTested") {
                this.genoTypePossitive = false
                this.genotype_mutation = 0
            } else {
                this.genoTypePossitive = true
                this.totalResult = ""
            }
        },
        bsa_fml(w, h) {
            return (
                Math.exp(0.3964 * Math.log(h)) *
                Math.exp(0.5378 * Math.log(w)) *
                0.024265
            );
        },
        ivsd_z_fml(ivsd, bsa) {
            return (
                (ivsd - (0.45686 * Math.pow(bsa, 0.59577) + 0.18722)) /
                (0.02033 + 0.04698 * bsa)
            );
        },
        lvpwd_z_fml(lvpwd, bsa) {
            return (
                (lvpwd - (0.3767 * Math.pow(bsa, 0.72326) + 0.243)) /
                (0.0371 + 0.02776 * bsa)
            );
        },
        la_systole_z_fml(la, bsa) {
            return (
                (Math.log10(la) -
                    Math.log10(
                        Math.pow(10, 0.81375 * Math.pow(bsa, 0.20444) - 0.43308)
                    )) /
                (0.07447 - 0.01478 * bsa)
            );
        },
        formValidate(e) {
            if(this.wgt_kg === ''){
                this.riskKidsCalculatorResultValidation = false
            } else if(this.wgt_kg > 150 ||this.wgt_kg < 2) {
                this.riskKidsCalculatorResultValidation = false
            } 

            else if(this.la_systole_mm === '') {
                this.riskKidsCalculatorResultValidation = false
            }else if(this.la_systole_mm > 80 || this.la_systole_mm < 3){
                this.riskKidsCalculatorResultValidation = false
            } 

           else if(this.peak_grad_mmhg === ''){
                this.riskKidsCalculatorResultValidation = false
            } else if(this.peak_grad_mmhg > 200 || this.peak_grad_mmhg <0) {
                this.riskKidsCalculatorResultValidation = false
            }

           else if(this.lvpwd_mm === ''){
                this.riskKidsCalculatorResultValidation = false
            } else if(this.lvpwd_mm > 70 || this.lvpwd_mm < 4){
                this.riskKidsCalculatorResultValidation = false
            } else {
                this.riskKidsCalculatorResultValidation = true
            }


            ///primacy cal start from here
            if(this.wgt_kg === ''){
                this.primacyCalculatorResulatValidation = false
            } else if(this.wgt_kg > 150 || this.wgt_kg < 1) {
                this.primacyCalculatorResulatValidation = false
            } 

            else if(this.hgt_cm === ''){
                this.primacyCalculatorResulatValidation = false
            } else if(this.hgt_cm > 190 || this.hgt_cm < 25) {
               
                this.primacyCalculatorResulatValidation = false
            } 

           else  if(this.la_systole_mm === ''){
                this.primacyCalculatorResulatValidation = false
            } else if(this.la_systole_mm > 55 || this.la_systole_mm < 5) {
                this.primacyCalculatorResulatValidation = false
            }

            else if(this.peak_grad_mmhg === ''){
                this.primacyCalculatorResulatValidation = false
            } else if(this.peak_grad_mmhg > 210 || this.peak_grad_mmhg <0) {
                this.riskKidsCalculatorResultValidation = false
            }

           

            else if(this.ivsd_mm === ''){
                this.primacyCalculatorResulatValidation = false
            } else if(this.ivsd_mm > 43 || this.ivsd_mm< 0.5) {
                this.primacyCalculatorResulatValidation = false
            } else if(this.posterLVWall === '') {
                this.primacyCalculatorResulatValidation = false
            }
            else if( this.posterLVWall > 60 || this.posterLVWall < 0.5) {
                this.primacyCalculatorResulatValidation = false
            }
            else {
                this.primacyCalculatorResulatValidation = true
            } 

            if( this.primacyCalculatorResulatValidation && this.riskKidsCalculatorResultValidation){
                this.validationModal = false
                this.isShowModal = true
                this.mainScreen = true
                this.calculate_sdc_risk()
            } else {
                this.validationModal = true
            }
            


        },
        validationFiled(val) {
            if (val === 'Height') {
                 if(this.hgt_cm > 190 || this.hgt_cm < 25){
                    this.heightValidationError =  this.heightErrorMessage;
                    
                 //   this.primacyCalculatorResulatValidation = false
                }
                 else {
               
                    this.heightValidation = false;
                    this.heightValidationError = ""
                   //this.primacyCalculatorResulatValidation = true
                }
            }

            if (val === 'weight') {
                if (this.wgt_kg === "") {
                    this.weightValidationError =  this.weightErrorMessage;
                } 
                else if (this.wgt_kg < 2 && this.wgt_kg >= 1) {
                  //  this.riskKidsCalculatorResultValidation = false;
                    this.weightValidationError ="Due to value entered, HCM Risk Kids cannot be computed."
                } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
                    this.weightValidationError =
                        this.weightErrorMessage;
                       
                      //  this.primacyCalculatorResulatValidation = false
                      //  this.riskKidsCalculatorResultValidation = true;
                } else {
                    this.weightValidationError = ""
                   // this.riskKidsCalculatorResultValidation = true;
                   // this.primacyCalculatorResulatValidation = true
                 
                }
            }

            if (val === "ivsd_mm") {
                if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                    this.ivsd_mm_validationError =
                        this.isdErrorMessage;
                      
                      //  this.primacyCalculatorResulatValidation = false
                       // this.riskKidsCalculatorResultValidation = true
                } else {
                    this.ivsd_mm_validationError = ""
                   // this.primacyCalculatorResulatValidation = true
                  //  this.riskKidsCalculatorResultValidation = true
                }
            }

           

            if (val === 'lvpwd_mm') {
                if(this.lvpwd_mm === ''){
                    this.lvpwd_mm_validationError = this.mlvwtErrorMessage
                }
            //    else  if(this.lvpwd_mm < 4 && this.lvpwd_mm > 0.5) {
                  
            //         this.lvpwd_mm_validationError =
            //         "Due to value entered, HCM Risk Kids cannot be computed.";
            //        // this.riskKidsCalculatorResultValidation = false
            //        // this.primacyCalculatorResulatValidation = true
                   
            //     }
                // else if(this.lvpwd_mm > 60 && this.lvpwd_mm < 70) {
                //     this.lvpwd_mm_validationError =
                //     "Due to value entered, PRIMaCY cannot be computed.";
                  
                // }
                else if (this.lvpwd_mm > 70 || this.lvpwd_mm < 4) {
                   
                    this.lvpwd_mm_validationError =
                    this.mlvwtErrorMessage;

                }
                  else {
                    this.lvpwd_mm_validationError = ""
                   
                }

                // if(this.lvpwd_mm > 0.5 || this.lvpwd_mm < 70) {
                //     this.lvpwd_mm_validationError =
                //     this.mlvwtErrorMessage;
                // } else {
                //     this.lvpwd_mm_validationError = ""
                // }

                // if(this.lvpwd_mm > 4 || this.lvpwd_mm < 70) {
                //     this.riskKidsCalculatorResultValidation = true;
                // } else {
                //     this.riskKidsCalculatorResultValidation = false;
                // }

                // if(this.lvpwd_mm > 0.5 || this.lvpwd_mm < 60) {
                //     this.primacyCalculatorResulatValidation = true;
                // } else {
                //     this.primacyCalculatorResulatValidation = false;
                // }

            }

            if (val === "la_systole_mm") {
                if(this.la_systole_mm === ''){
                    this.la_systole_mm_validationError = this.laSizeErrorMessage;
                }
                else if (this.la_systole_mm < 3 || this.la_systole_mm > 80) {

                this.la_systole_mm_validationError = this.laSizeErrorMessage;
                
 
                } 
               else if(this.la_systole_mm < 5 || this.la_systole_mm > 55) {
                   
                    this.la_systole_mm_validationError =
                    "Due to value entered, PRIMaCY cannot be computed.";
                   // this.primacyCalculatorResulatValidation = false
                  //  this.riskKidsCalculatorResultValidation = true
                }
               
                 else {
                    this.la_systole_mm_validationError = ""
                   // this.primacyCalculatorResulatValidation = true
                   // this.riskKidsCalculatorResultValidation = true
                }
            }

            if (val === 'peak_grad_mmhg') {
                if(this.peak_grad_mmhg === ''){
                    this.peak_grad_mmhg_validationError = "Max LVOT Gradient must be between 0 and 210 mmHg."
                   // this.maxLvotGradientErrorMessage;
                }
                else if (this.peak_grad_mmhg < 0 || this.peak_grad_mmhg > 210) {
                   // console.log ('working')
                    this.peak_grad_mmhg_validationError = "Max LVOT Gradient must be between 0 and 210 mmHg."
                        //this.maxLvotGradientErrorMessage;
                       
                        //this.primacyCalculatorResulatValidation = false
                }
                 else if (this.peak_grad_mmhg  > 200 && this.peak_grad_mmhg  < 210) {
                    
                    this.peak_grad_mmhg_validationError = "Due to value entered, HCM Risk Kids cannot be computed."
                  //  this.riskKidsCalculatorResultValidation = false
                }
                    else {
                    this.peak_grad_mmhg_validationError = "";
                    // this.riskKidsCalculatorResultValidation = true
                    // this.primacyCalculatorResulatValidation = true
                }
            }

            if(val === 'posterLVWall') {
                if(this.posterLVWall === ''){
                    this.posterLVWall_validationError = this.posteriorLvErrorMessage
                }
                else if ( this.posterLVWall > 60 || this.posterLVWall < 0.5) {
                   
                this.posterLVWall_validationError =this.posteriorLvErrorMessage
                }  else {
                    this.posterLVWall_validationError = ""
                }
            }

        },

        validationBack() {
            this.validationModal = false
            this.mainScreen = false
            this.isShowModal = false
        },

        calculate_sdc_risk() {
           
            this.isShowModal = true
            this.validationModal = false
            this.mainScreen = true
            let age_yr = this.userAgeValue;
            let hgt_cm = this.hgt_cm;
            let wgt_kg = this.wgt_kg;
            let ivsd_mm = this.ivsd_mm;
            let lvpwd_mm = this.lvpwd_mm;
            let la_systole_mm = this.la_systole_mm;
            let peak_grad_mmhg = this.peak_grad_mmhg;
            let genotype_mutation = this.genotype_mutation == 0 ? null : this.genotype_mutation_yes === 0 ? false : true
                // console.log ('this.genotype_mutation', this.genotype_mutation, genotype_mutation)
            let bodySurfaceArea = 0.1023 * Math.pow(this.wgt_kg, 0.68)
            let roundedNumber = parseFloat(bodySurfaceArea.toFixed(8))
            // console.log ('bodySurfaceArea', roundedNumber)
            let convertCMMM = this.lvpwd_mm/10;
            // console.log('convertCMMM', convertCMMM)
            let LVMWTZ = ((convertCMMM / Math.pow(bodySurfaceArea, 0.4)) - 0.58) / 0.09;
            // console.log('LVMWTZ', LVMWTZ)
            this.lv_Zz_score = parseFloat(LVMWTZ.toFixed(9))
            // console.log('this.lv_Zz_score', this.lv_Zz_score)
            // console.log ('this.sex_range', this.sex_range)
            let laDiameterZScore = this.sex_range == "0" ? ((la_systole_mm / (10.665 * Math.pow(this.wgt_kg, 0.255))) - 1) / 0.118 :  ((la_systole_mm / (10.74 * Math.pow(this.wgt_kg, 0.246))) - 1) / 0.124
            let sexRangeValue = parseFloat(laDiameterZScore.toFixed(9))
            // console.log('laDiameterZScore', laDiameterZScore)
            this.la_dia_score = sexRangeValue
            let firstStep = (0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12))
            // console.log('firstStep', firstStep)
            let secondStep = + 0.130365 * (sexRangeValue - 1.92)
            // console.log ('secondStep', secondStep)
            let thirdStep = - 0.0065555 * (this.peak_grad_mmhg - 21.8)
            // console.log ('thirdStep', thirdStep)
            let fourthStep = + 0.1861694 * this.non_vt
            //console.log ('fourthStep', fourthStep , 'hx_nsvt', hx_nsvt)
            let fifthStep =  + 0.429624 * this.un_sy
            // console.log ('fifthStep', fifthStep)
            // console.log ('this.peak_grad_mmhg', this.peak_grad_mmhg)
            let PrognosticTotal =    (0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12)) + 0.130365 * (sexRangeValue - 1.92)- 0.0065555 * (this.peak_grad_mmhg - 21.8)+ 0.1861694 * this.non_vt + 0.429624 * this.un_sy
                // parseFloat(secondStep.toFixed(9)) + 
                // parseFloat(thirdStep.toFixed(9)) + 
                // fourthStep + 
                // fifthStep;
            let totalPrognosticTotal = parseFloat(PrognosticTotal.toFixed(9))
        //    console.log('totalPrognosticTotal', totalPrognosticTotal)
            this.PrognosticTotal = totalPrognosticTotal
            const base = 0.949437808;
            const powerResult = Math.pow(base, Math.exp(PrognosticTotal));
            this.RiskKidsTotalResult = ((1 - powerResult) * 100).toFixed(2) + '%'
            // console.log ('RiskKidsTotalResult', this.RiskKidsTotalResult)
            let ivsd_scd_spline;
            let lvpwd_scd_spline;
            let la_scd_spline;
            let grad_scd_spline;
            let age_scd_spline;
            let nsvt_scd_spline;
            let syncope_scd_spline;
            let gene_scd_spline;
            let age_oth_spline;
            let cif_obj;
            let prog_idx_scd_calib_factor;
            let prog_idx_oth_calib_factor;
            if (genotype_mutation == null) {
                ivsd_scd_spline = no_genotype_spline_functions_1.no_genotype_ivsd_scd_spline;
                lvpwd_scd_spline = no_genotype_spline_functions_1.no_genotype_lvpwd_scd_spline;
                la_scd_spline = no_genotype_spline_functions_1.no_genotype_la_scd_spline;
                grad_scd_spline = no_genotype_spline_functions_1.no_genotype_grad_scd_spline;
                age_scd_spline = no_genotype_spline_functions_1.no_genotype_age_scd_spline;
                nsvt_scd_spline = no_genotype_spline_functions_1.no_genotype_nsvt_scd_spline;
                syncope_scd_spline = no_genotype_spline_functions_1.no_genotype_syncope_scd_spline;
                gene_scd_spline = no_genotype_spline_functions_1.no_genotype_genotype_scd_spline;
                age_oth_spline = no_genotype_spline_functions_1.no_genotype_age_oth_spline;
                cif_obj = no_genotype_baseline_hazard_1.no_genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.30563989776015;
                prog_idx_oth_calib_factor = 5.84865347533236;
            }
            else {
                ivsd_scd_spline = genotype_spline_functions_1.genotype_ivsd_scd_spline;
                lvpwd_scd_spline = genotype_spline_functions_1.genotype_lvpwd_scd_spline;
                la_scd_spline = genotype_spline_functions_1.genotype_la_scd_spline;
                grad_scd_spline = genotype_spline_functions_1.genotype_grad_scd_spline;
                age_scd_spline = genotype_spline_functions_1.genotype_age_scd_spline;
                nsvt_scd_spline = genotype_spline_functions_1.genotype_nsvt_scd_spline;
                syncope_scd_spline = genotype_spline_functions_1.genotype_syncope_scd_spline;
                gene_scd_spline = genotype_spline_functions_1.genotype_genotype_scd_spline;
                age_oth_spline = genotype_spline_functions_1.genotype_age_oth_spline;
                cif_obj = genotype_baseline_hazard_1.genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.352992544571569;
                prog_idx_oth_calib_factor = 5.84865347533236;
            }
            var age_idx = age_yr;
            var bsa = (0, z_functions_1.bsa_fml)(wgt_kg, hgt_cm);
            var ivsd_z_calc = (0, z_functions_1.ivsd_z_fml)(ivsd_mm / 10, bsa);
            console.log ('posterLVWall', posterLVWall)
            var lvpwd_z_calc = (0, z_functions_1.lvpwd_z_fml)(this.posterLVWall / 10, bsa);
            var la_z_calc = (0, z_functions_1.la_systole_z_fml)(la_systole_mm / 10, bsa);
            var peak_grad_first_echo = peak_grad_mmhg;

            if (this.non_vt == 1) {
                var non_sustained_vt = 1;
            } else {
                var non_sustained_vt = 0;
            }
            if (this.un_sy == 1) {
                var history_syncope = 1;
            } else {
                var history_syncope = 0;
            }
            var prog_idx_scd_uncal =
                ivsd_scd_spline(ivsd_z_calc) +
                lvpwd_scd_spline(lvpwd_z_calc) +
                la_scd_spline(la_z_calc) +
                grad_scd_spline(peak_grad_first_echo) +
                age_scd_spline(age_idx) +
                nsvt_scd_spline(non_sustained_vt) +
                syncope_scd_spline(history_syncope) +
                gene_scd_spline(genotype_mutation);
            var prog_idx_oth_uncal = age_oth_spline(age_idx);
            var prog_idx_scd = prog_idx_scd_calib_factor * prog_idx_scd_uncal;
            var prog_idx_oth = prog_idx_oth_calib_factor * prog_idx_oth_uncal;
            var prevBaseCumHazSCD = 0;
            var prevBaseCumHazOth = 0;
            var prevPrevBaseCumHazSCD = 0;
            var prevPrevBaseCumHazOth = 0;
            var cumulativeProdSurvPrev = 1;
            var cumulativeSumCIFSCD = 0;
            let cif_result = [];
            cif_obj.forEach(function (entry) {
                entry.hazard_scd =
                    entry.cumhaz0_scd * Math.exp(prog_idx_scd) -
                    prevBaseCumHazSCD * Math.exp(prog_idx_scd);
                if (entry.day_prev_evt == 0) {
                    entry.hazard_ttl = 0;
                } else {
                    entry.hazard_ttl =
                        (prevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevBaseCumHazOth * Math.exp(prog_idx_oth)) -
                        (prevPrevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevPrevBaseCumHazOth * Math.exp(prog_idx_oth));
                }
                prevPrevBaseCumHazSCD = prevBaseCumHazSCD;
                prevPrevBaseCumHazOth = prevBaseCumHazOth;
                prevBaseCumHazSCD = entry.cumhaz0_scd;
                prevBaseCumHazOth = entry.cumhaz0_oth;
                entry.one_minus_hazard_ttl = 1 - entry.hazard_ttl;
                cumulativeProdSurvPrev *= entry.one_minus_hazard_ttl;
                entry.surv_prev = cumulativeProdSurvPrev;
                cumulativeSumCIFSCD += entry.hazard_scd * entry.surv_prev;
                entry.cif_scd = cumulativeSumCIFSCD;
                cif_result.push(entry);
            });
            this.primacyTotalResult = (cif_result[cif_result.length - 1]['cif_scd'] * 100).toFixed(2) + "%";
            console.log ('primacyTotalResult', this.primacyTotalResult)
            return cif_result[cif_result.length - 1]['cif_scd'];

            
            

        },

        handleIconValidatoin(val) {
            if (val === 'height') {
                this.heightRangeIcon = !this.heightRangeIcon
            }

            if (val === 'weight') {
                this.weightRangeIcon = !this.weightRangeIcon
            }

            if (val === 'ivsd_mm') {
                this.ivsd_mmRangeIcon = !this.ivsd_mmRangeIcon
            }

            if (val === "lvpwd_mm") {
                this.lvpwd_mmRangeIcon = !this.lvpwd_mmRangeIcon
            }

            if (val === 'la_systole_mm') {
                this.la_systole_mmRangeIcon = !this.la_systole_mmRangeIcon
            }

            if (val === "peak_grad_mmhg") {
                this.peak_grad_mmhgRangeIcon = !this.peak_grad_mmhgRangeIcon
            }

            if (val === "lv_Zz_score") {
                this.lv_Zz_scoregRangeIcon = !this.lv_Zz_scoregRangeIcon
            }

            if (val === "la_dia_score") {
                this.ladiascoreRangeIcon = !this.ladiascoreRangeIcon
            }

            if (val === "HistoryVentricular") {
                this.HistoryVentricularRangeIcon = !this.HistoryVentricularRangeIcon
            }

            if (val === "HistoryUnexplained") {
                this.HistoryUnexplainedRangeIcon = !this.HistoryUnexplainedRangeIcon
            }

            if (val === "Genotypestatus") {
                this.GenotypestatusRangeIcon = !this.GenotypestatusRangeIcon
            }

            if (val === "Genotypepositive") {
                this.GenotypepositiveRangeIcon = !this.GenotypepositiveRangeIcon
            }

            if (val === "nonVt") {
                this.nonVtRangeIcon = !this.nonVtRangeIcon
            }

            if (val === "UnexplainedSyncope") {
                this.UnexplainedSyncopeIcon = !this.UnexplainedSyncopeIcon
            }
        },

        resetForm() {
            this.posterLVWall = "";
            this.sex_range = 0;
            this.hgt_cm = "";
            this.wgt_kg = "";
            this.ivsd_mm = "";
            this.lvpwd_mm = "";
            this.la_systole_mm = "";
            this.peak_grad_mmhg = "";
            this.hx_nsvt = 0;
            this.hx_syncope = 0;
            this.testedStatus = "";
            this.totalResult = "";
            this.ageValidationError = "";
            this.heightValidationError = "";
            this.weightValidationError = "";
            this.ivsd_mm_validationError = "";
            this.lvpwd_mm_validationError = "";
            this.la_systole_mm_validationError = "";
            this.peak_grad_mmhg_validationError = "";
            this.isLoading = "";
            this.isShowModal = false;
            this.ageValidation = false;
            this.heightValidation = false;
            this.weightValidation = false;
            this.ivsd_mm_Validation =  false;
            this.lvpwd_mm_validation =  false;
            this.la_systole_mm_validation = false;
            this.peak_grad_mmhg_validation = false;
            this.genoTypePossitive = false;
            this.genotype_mutation = 0;
            this.genotype_mutation_yes= 0;
            this.non_vt = 0;
            this.un_sy = 0;
            this.lv_Zz_score = "";
            this.heightRangeIcon =false;
            this.weightRangeIcon= false;
            this.ivsd_mmRangeIcon= false;
            this.lvpwd_mmRangeIcon=false;
            this.la_systole_mmRangeIcon = false;
            this.peak_grad_mmhgRangeIcon= false;
            this.lv_Zz_scoregRangeIcon = false;
            this.ladiascoreRangeIcon = false;
            this.HistoryVentricularRangeIcon =false;
            this.HistoryUnexplainedRangeIcon = false;
            this.GenotypestatusRangeIcon =false;
            this.GenotypepositiveRangeIcon = false;
            this.nonVtRangeIcon= false;
            this.UnexplainedSyncopeIcon = false;
            this.validationModal = false;
            this.mainScreen = false;
       
        },
    },
    mounted() {
        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child

        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on("bv::modal::hidden", ($event) => {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);
        });
    },
    watch: {
        hx_nsvt(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_nsvt = 1;
                console.log("this.hx_nsvt", this.hx_nsvt);
            } else if (oldVal === 1) {
                this.hx_nsvt = 0;
            }
        },
        hx_syncope(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_syncope = 1;
                console.log("this.hx_syncope", this.hx_syncope);
            } else {
                this.hx_syncope - 0;
            }
        },
        
    },
};
</script>
<style>

.custom-recommedation-text {
    font-weight: normal !important;
  }
  
.custom-cal-link {
    width: 270px;
    margin-left: -20px;
    text-decoration: none;
    text-align: left;
}

.custom-cal-link::after {
    font-size: 10px;
    margin-top:-5px;
}

.custom-modal-cal {
    width: 310px !important;
    border-top:6px solid #ed0a22;
    background: #fff;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.2);
    padding: 48px 18px 36px;
    z-index: 2;
}

.custom-start-over {
    border: 1px solid #ed0a22 !important;
    padding: 10px 12px !important;
    border-radius: 50px;

}

.custom-modal-cal p {
   color: black !important;
   font-weight: 600;
}

.is-invalid {
    border-color: #ed0a22 !important;
}

.c-hero-card-snackable__content {
    left: 0px !important;
}

textarea.form-control,
.c-aha-form textarea {
    padding: 10px;
    min-height: 100px;
}

.lower {
    margin-top: 45px;
}

@include media-breakpoint-up(sm) {
    .lower {
        margin-top: 50px;
    }
}

a.icon {
    width: 30px;
    height: 30px;
    background: #ed0a22;
    border-radius: 50%;
    border: thin solid #ed0a22;
    color: #fff !important;
    font-weight: bold;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

a.icon:hover {
    color: #fff;
}

#risk,
#recommendation,
.toolTip {
    background-color: #e9ecef;
    opacity: 1;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-clip: padding-box;
    border: 1px solid #c4cacf;
    border-radius: 2px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.validation-modal-style  {
    color: #ed0a22;
    font-weight: 600;
    font-size: 12px;
}

.validation-modal-header {
  
    width: fit-content;
}

.modal.show .modal-dialog-centered .modal-content {
  overflow: hidden;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// demo/pages/components/risk-kids-primacy.vue